import React from 'react'
import { useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'

import { selectors } from '../redux'
import { router, routesPath } from '../router'

import Loader from './Loader'

interface AuthGuardType {
  children: React.ReactNode
}

// For routes that can only be accessed by authenticated users
function AuthGuard({ children }: AuthGuardType) {
  const isConnected = useSelector(selectors.auth.isConnected)
  const isLoading = useSelector(selectors.auth.isLoading)

  if (!isConnected && !isLoading) {
    return <Navigate to={router(routesPath.onboarding)} />
  }

  if (isLoading) {
    return <Loader />
  }

  return children
}

export default AuthGuard
